<template>
<!-- eslint-disable max-len -->
  <div id="content-wrap">
    <!-- <div style="margin-top: 20px;">
      <title> Electric Vehicle Tools Home </title>
    </div> -->
    <div>
      <!-- <h5 id="title" role="banner">
        Electric Vehicle Events
      </h5> -->
      <h1 class="pageTitle" id="title" role="banner" style="margin-bottom: 0px;">
        Electric Vehicle Events
      </h1>
      <div class="paragraphGroup">
        <div class="paragraph" style="margin-top:20px; margin-bottom: 40px;" >
          {{$parent.event_page_description}}
        </div>
      </div>
        <!-- <div v-for="(event, index) in events" v-bind:key="index">
          {{event['Name']}}
        </div>  -->
        <div id="eventList" class="itemList" style="margin-left: 0;">
          <span class="loader" v-if="showLoading"></span>

          <div v-if="totalItems == 0 && !showLoading">
            There are no upcoming events at this time.
          </div>

          <!-- <div v-if="totalItems == 0 && !showLoading" style="margin: 20px 40px;">
            No EV models were found. Please update the selected filters<span v-if="state.filterLiked">, or deselect the Compare Favorites button</span>.
          </div> -->

          <!-- TODO: dynamic height, hide unset fields, etc -->
          <div v-for="(event, index) in getFilteredEventData()"
            v-bind:key="index"
            class="itemBlock"
            style="width:100%; height: auto; margin-left: 0;">

            <div style="margin-bottom: 15px;">
              <h6>{{event.Name}}</h6>
            </div>

            <img alt="Event Image" v-if="event.Event_Image"
              :src="event.Event_Image" style="float: right; margin:20px; height: 250px;"/>

            <div v-if="event.Event_Location" style="margin: 5px 0;">
              <b>Event Type:</b> <span>{{event.Event_Location}}</span>
              <br />
            </div>
            <div v-if="event.Street_Address" style="margin: 5px 0;">
              <b>Street:</b> <span>{{event.Street_Address}}</span>
              <br />
            </div>
            <div v-if="event.City" style="margin: 5px 0;">
              <b>City:</b> <span>{{event.City}}</span>
              <br />
            </div>
<!--             <div v-if="event.Event_Type">
              <b>Type:</b> <span>{{event.Event_Type}}</span>
              <br />
            </div> -->
            <div v-if="event.Date" style="margin: 5px 0;">
              <b>Date:</b> <span>{{event.Date}}</span>
              <br />
            </div>
            <div v-if="event.Event_Description" style="margin: 5px 0;">
              <b>Event Description:</b> <br/>
              <span style="white-space: pre-wrap;">{{event.Event_Description}}</span>
            </div>
            <div v-if="event.Event_Signup || event.Event_Website" style="margin-top: 15px;">
              <button v-if="event.Event_Signup" class="buttonStyle" @click="changeRoute(event.Event_Signup)"> Register Here </button>
              <button v-if="event.Event_Website" class="buttonStyle" @click="changeRoute(event.Event_Website)"> Find Out More </button>
            </div>
          </div>

          <div class="itemBlockSpacer"></div>
          <div class="itemBlockSpacer"></div>
          <div class="itemBlockSpacer"></div>
          <div class="itemBlockSpacer"></div>
          <div class="itemBlockSpacer"></div>
          <!-- <img v-bind:src="event.Event_Image" width=400 alt="Car"  /> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
<!-- eslint-enable max-len -->
</template>

<script>
/* eslint-disable no-console */
import axios from 'axios';

export default {
  data() {
    return {
      events: [],
      showLoading: true,
      totalItems: null,
    };
  },
  mounted() {
    const mutationObserver = new MutationObserver((mutationsList) => {
      Array.from(mutationsList).forEach(() => {
        this.busy = false;
        this.showLoading = false;
      });
    });
    mutationObserver.observe(document.querySelector('.itemList'), { attributes: true, childList: true, subtree: true });
  },
  methods: {
    getEventData() {
      const path = `${this.$baseUrl}/data/${this.$parent.client_api_path}/events`;
      axios.get(path)
        .then((res) => {
          // console.log('events res', res.data.events);
          this.events = res.data.events;
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    getFilteredEventData() {
      const sortDir = -1;
      const filtered = this.events.filter((event) => this.passesFilters(event));
      const sorted = filtered.sort((a, b) => sortDir * new Date(b.Date)
        - sortDir * new Date(a.Date));
      this.totalItems = sorted.length;

      if (sorted.length === 0) {
        return [];
        // Handle no events by displaying below:
        // return [{ Name: 'There are no upcoming events at this time.' }];
      }
      return sorted;
    },
    passesFilters(event) {
      // const eventStr = JSON.stringify(event);
      return event.Date && new Date(event.Date) > new Date();
      // if (this.state.searchInput
      //   && !carStr.toUpperCase().includes(this.state.searchInput.toUpperCase())) {
      //   return false;
      // }

      // return true;
    },
  },
  created() {
    this.getEventData();
    // console.log('this.events is now: ', this.events);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #eventList {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: clamp(20px, 5vw, 40px);
  }
  #eventList .itemBlock {
    flex: 1 0 45%;
    margin-bottom: 0;
  }
  .itemBlockSpacer {
    flex: 1 0 45%;
    margin: 0;
  }
  @media (max-width: 1000px) {
    #eventList .itemBlock {
      flex: 1 0 100%;
    }
  }
</style>
